// `unstable_createMuiStrictModeTheme` is used to suppress `findDOMNode` error messages
// reference: https://stackoverflow.com/a/64135466
import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme();

export default theme;
